import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ReservationBySourceResponseV4, RevenueBySourceResponseV4 } from "../response/SourceOfBookingResponseV4";

const API_VERSION = "v4";

// Interface untuk parameter filter yang akan digunakan oleh kedua hook
interface ParamsSourceOfBookingV4 {
    property_id: string;
    start_date?: string;
    end_date?: string;
}

interface SourceOfBookingV4Props {
    filters: ParamsSourceOfBookingV4;
    enabled?: boolean;
}

/**
 * Hook untuk mengambil data jumlah reservasi berdasarkan sumber (V4)
 */
export const useReservationBySource = (query: SourceOfBookingV4Props) => {
    return useQuery({
        queryKey: [
            'reservation-by-source-v4',
            ...Object.entries(query.filters ?? {}).map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            const params = { filter: query.filters };
            const response = await privateApi.get(`/${API_VERSION}/fos/statistics/reservation`, { params });
            const validationResult = ReservationBySourceResponseV4.safeParse(response.data);
            if (!validationResult.success) {
                throw new Error("Invalid Reservation by Source V4 data format");
            }
            return validationResult.data;
        },
        enabled: query.enabled !== false && !!query.filters.property_id, // Hanya aktif jika property_id ada dan enabled tidak false
        retry: 1,
        refetchOnWindowFocus: false,
    });
};

/**
 * Hook untuk mengambil data pendapatan berdasarkan sumber (V4)
 */
export const useRevenueBySource = (query: SourceOfBookingV4Props) => {
    return useQuery({
        queryKey: [
            'revenue-by-source-v4',
            ...Object.entries(query.filters ?? {}).map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            const params = { filter: query.filters };
            const response = await privateApi.get(`/${API_VERSION}/fos/statistics/revenue`, { params });
            const validationResult = RevenueBySourceResponseV4.safeParse(response.data);
            if (!validationResult.success) {
                throw new Error("Invalid Revenue by Source V4 data format");
            }
            return validationResult.data;
        },
        enabled: query.enabled !== false && !!query.filters.property_id, // Hanya aktif jika property_id ada dan enabled tidak false
        retry: 1,
        refetchOnWindowFocus: false,
    });
};